<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">
            访问日志
          </span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <!--<div slot="header">-->
      <!--<el-button-->
      <!--type="danger"-->
      <!--slot="reference"-->
      <!--plain-->
      <!--@click="deleteAll()"-->
      <!--size="small"-->
      <!--&gt;-->
      <!--清空-->
      <!--</el-button>-->
      <!--</div>-->
      <el-table
        ref="multipleTable"
        :data="siteLogList"
        tooltip-effect="dark"
        stripe
        style="width: 100%;"
        height="417"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="logId" label="日志ID" sortable align="center">
        </el-table-column>
        <el-table-column label="访问目标" prop="logType" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.logType === 1">浏览网站</el-tag>
            <el-tag type="danger" v-if="scope.row.logType === 2"
              >IOS点击</el-tag
            >
            <el-tag type="success" v-if="scope.row.logType === 3"
              >Android下载</el-tag
            >
            <el-tag type="warning" v-if="scope.row.logType === 4"
              >浏览新闻</el-tag
            >
            <el-tag type="primary" v-if="scope.row.logType === 5"
              >浏览招聘</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作系统" prop="logSys" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.logSys === 1">pc</el-tag>
            <el-tag type="success" v-if="scope.row.logSys === 2">安卓</el-tag>
            <el-tag type="danger" v-if="scope.row.logSys === 3">ios</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="logRecordName"
          label="目标名称"
        ></el-table-column>
        <el-table-column prop="logIp" label="ip地址" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          label="访问时间"
          align="center"
          width="150"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[6, 10, 20, 100, 200, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "SiteLogList",
  data() {
    return {
      siteLogList: [],
      loading: false,
      currentPage: 1,
      pageSize: 6,
      total: 0
    };
  },
  mounted() {
    this.getSiteLogList();
  },
  methods: {
    getSiteLogList() {
      this.loading = true;
      this.axios
        .get("/siteLog/getSiteLogList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.siteLogList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSiteLogList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSiteLogList();
    }
    // deleteAll() {
    //   this.$confirm("此操作清空所有日志信息, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(() => {
    //       this.axios.delete("/siteLog/deleteAllSiteLog").then(resp => {
    //         if (resp && resp.data.code === 10000 && resp.data.success) {
    //           this.getSiteLogList();
    //           this.$message({
    //             type: "success",
    //             message: "删除成功!"
    //           });
    //         }
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除"
    //       });
    //     });
    // }
  }
};
</script>

<style scoped></style>
